import { BaseApiService } from './baseApiService';
import {
  SignatureData,
  SigningPageData,
  ApiResponse,
  SubmitSignaturePayload,
  SubmitSignatureData,
} from '../../types/signature.types';

class SignatureService extends BaseApiService {
  async getSigningPageData(token: string): Promise<SigningPageData> {
    const response: ApiResponse<SigningPageData> = await this.fetchPublic(
      `/patient-sign/${token}/`
    );
    return response.data;
  }

  async submitSignature(
    sessionToken: string,
    signatureData: SignatureData,
    useExisting: boolean = false
  ): Promise<SubmitSignatureData> {
    const payload = this.buildSubmitPayload(signatureData, useExisting);
    const response: ApiResponse<SubmitSignatureData> = await this.fetchPublic(
      `/patient-sign/${sessionToken}/submit/`,
      {
        method: 'POST',
        body: JSON.stringify(payload),
      }
    );
    return response.data;
  }

  private buildSubmitPayload(
    data: SignatureData,
    useExisting: boolean
  ): SubmitSignaturePayload {
    if (useExisting) {
      return {
        signature_type: data.method,
        use_existing: true,
      };
    }

    let signatureDataValue: string | null = null;
    switch (data.method) {
      case 'text':
        signatureDataValue = data.textSignature || null;
        break;
      case 'digital':
        signatureDataValue = data.digitalSignature || null;
        break;
      case 'placeholder':
        signatureDataValue = null;
        break;
    }

    return {
      signature_type: data.method,
      signature_data: signatureDataValue,
      use_existing: false,
    };
  }
}

export const signatureService = new SignatureService();
